import * as React from 'react'
import PropTypes from 'prop-types'
import Badge from '../Badge'

export const recruitStatusColorMap = {
  "not yet recruiting": "blue",
  "recruiting": "green",
  "terminated": "red",
  "default": "gray",
}

const RecruitmentBadge = ({
  value,
}) => {
  const colorKey = React.useMemo(() => {
    if (!value) return null;
    let key = value?.toLowerCase()
    if (key === 'not yet recruiting'
      || key === 'recruiting') return key;
    if (key === 'recruiting'
      || key === 'completed'
      || key === 'active'
      || key === 'enrolling by invitation') return 'recruiting';
    if (key.startsWith('terminated')) return 'terminated'
    return 'default'
  }, [value])

  if (!value) return null;

  return <div style={{ display: 'flex' }}>
    <Badge
      value={value}
      colorName={recruitStatusColorMap[colorKey] || "gray"}
    />
  </div>
}

RecruitmentBadge.propTypes = {
  value: PropTypes.string,
}

export default RecruitmentBadge